var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"metricContainer"},[_c('NumeraiTooltip',{attrs:{"text":_vm.tooltipText}},[_c('span',{staticClass:"label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_c('span',{staticClass:"value"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }